import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { LogDetail } from '../models/log-detail';

@Injectable()
export class LoggerService {

  constructor(private _http: Http) { }

  //find who called
  logError(error: any, component: string, func: string, additionalDetails?: LogDetail[]) {
    var options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');

    var details: LogDetail[] = [];
    var message = `${component} ${func} Ok: ${error.ok}, status: ${error.status}, statusText: ${error.statusText}, type: ${error.type}, url: ${error.url}, body: ${error._body}`;
    var logDetail = new LogDetail();
    logDetail.message = message;
    details.push(logDetail);

    if (additionalDetails.length > 0) {
      for (var i = 0, len = additionalDetails.length; i < len; i++) {
        additionalDetails[i].message
        details.push(additionalDetails[i]);
      }
    }

    return this._http.post(`${environment.apiRootURL}/weblogger`, details, options).map(response => response.json());
  }

  //logSuccess(component: string, func: string) {
  //  var options = new RequestOptions();
  //  options.headers = new Headers();
  //  options.headers.append('Content-Type', 'application/json');

  //  var details: LogDetail[] = [];
  //  var message = `${component} ${func} Successful`;
  //  var logDetail = new LogDetail();
  //  logDetail.message = message;
  //  details.push(logDetail);

  //  return this._http.post(`${environment.apiRootURL}/weblogger`, details, options).map(response => response.json());
  //}

}



// WEBPACK FOOTER //
// ./src/app/services/logger.service.ts